import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { Tooltip, Badge } from 'framework/ui/mui-builder';
import { BadgeLayoutProps } from 'framework/ui/uiContract';
import { useUiTheme } from 'framework/uiTheme';

// All stages - Expand as needed
const DOCUMENT_STAGES = {
  UPLOADED: 'UPLOADED',
  SIGNED: 'SIGNED',
  IN_PROCESS: 'IN_PROCESS',
  PARTIALLY_SIGNED: 'PARTIALLY_SIGNED',
  ANNULLED: 'ANNULLED',
} as const;

const DOCUMENT_STAGES_VALUES = {
  [DOCUMENT_STAGES.UPLOADED]: 'Uploaded',
  [DOCUMENT_STAGES.SIGNED]: 'Signed',
  [DOCUMENT_STAGES.IN_PROCESS]: 'In process',
  [DOCUMENT_STAGES.PARTIALLY_SIGNED]: 'Partially signed',
  [DOCUMENT_STAGES.ANNULLED]: 'Annuled',
};

const DOCUMENT_STAGES_COLORS: Record<keyof typeof DOCUMENT_STAGES, BadgeLayoutProps['color']> = {
  [DOCUMENT_STAGES.UPLOADED]: 'success',
  [DOCUMENT_STAGES.SIGNED]: 'success',
  [DOCUMENT_STAGES.IN_PROCESS]: 'primary',
  [DOCUMENT_STAGES.PARTIALLY_SIGNED]: 'info',
  [DOCUMENT_STAGES.ANNULLED]: 'default',
};

const DocumentStageBadgeField = ({ source, annulReasonSource = 'metadata.annullingReason' }: FieldProps) => {
  const { Tooltip: ThemedTooltip = Tooltip, Badge: ThemedBadge = Badge } = useUiTheme();
  const { getValue: getStage } = useFieldHelper({ source });
  const { getValue: getAnnul } = useFieldHelper({ source: annulReasonSource });

  const badgeValue = getStage();
  const annulReasonValue = getAnnul();

  return (
    <ThemedTooltip title={annulReasonValue} placement="top">
      <div>
        <ThemedBadge
          color={DOCUMENT_STAGES_COLORS[badgeValue as keyof typeof DOCUMENT_STAGES_COLORS] || 'default'}
          sx={{
            ml: 0,
          }}
        >
          {DOCUMENT_STAGES_VALUES[badgeValue as keyof typeof DOCUMENT_STAGES] || DOCUMENT_STAGES_VALUES.UPLOADED}
        </ThemedBadge>
      </div>
    </ThemedTooltip>
  );
};

export default DocumentStageBadgeField;
